import createCrudVuexModule from "@/store/crud";

export const agreementType = createCrudVuexModule({
  namespaced: true,
  path: "/library/agreement-type",
  moduleName: `agreement-type`,
});

export const workspaceAgreementType = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/agreement-type",
});

export const managementAgreementType = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/agreement-type",
});
